import { WasteInvoiceImportVendor, WasteInvoiceLineKind } from "generated-graphql/graphql";
import { formatCurrency } from "util/currency";
import { prettyPrintDateMed } from "util/dates";

export const NO_VALUE = "—";

export function formatInvoiceDate(value: string | null | undefined): string {
  return value ? prettyPrintDateMed(value, { inputZone: "utc", outputZone: "utc" }) : NO_VALUE;
}

export function formatInvoiceMoney(value: unknown): string {
  return formatCurrency(value);
}

export function formatServicePeriod(
  start: string | null | undefined,
  end: string | null | undefined
): string {
  if (!start && !end) return NO_VALUE;
  if (start === end) return formatInvoiceDate(start);
  return `${formatInvoiceDate(start)} – ${formatInvoiceDate(end)}`;
}

export const LINE_KIND_LABELS: Record<WasteInvoiceLineKind, string> = {
  [WasteInvoiceLineKind.Waste]: "Waste",
  [WasteInvoiceLineKind.Service]: "Service",
  [WasteInvoiceLineKind.Product]: "Product",
  [WasteInvoiceLineKind.Surcharge]: "Surcharge",
  [WasteInvoiceLineKind.Other]: "Other",
};

export const IMPORT_VENDOR_LABELS: Record<WasteInvoiceImportVendor, string> = {
  [WasteInvoiceImportVendor.CleanEarth]: "Clean Earth",
  [WasteInvoiceImportVendor.Republic]: "Republic Services",
};
